import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../../utils/page-title";

export const Route = createFileRoute("/admin/utilities")({
  ssr: false,
  head: () =>
    pageHead("Admin Reference Desk", {
      canonicalPath: "/admin/utilities",
      robots: "noindex, nofollow",
    }),
});
